exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-2b3819ee]{cursor:pointer}.card-body-minimum[data-v-2b3819ee]{min-height:100px}", ""]);

// exports
